import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_electrical_wires_cables_switches_plugs_panels_distribution'

export const dataPointDefinition = {
  retracedId: 'are_electrical_wires_cables_switches_plugs_panels_distribution',
  name: 'Are electrical wires, cables, switches, plugs, panels, distribution boards, and equipment (e.g. transformers, generators, compressors, circuit breakers) installed, grounded (for equipment), maintained and in line with legal requirements?',
  description:
    'Service entrance cables (cables that transport electricity from the service provider to the main panel/transformer) must be protected and supported (e.g., placed within a floor trench, or a steel pipe).\r\r\n- All electrical equipment must be grounded/bonded (check legal requirements for generators, e.g. grounding in two locations)\r\r\n- Circuit breakers must be installed in the electrical panel box, which is made out of non-flammable material, and the door must be closed. Unless specified otherwise under national law, there should be approximately 1m of clearance between the electrical panel / box and work areas.\r\r\n- Switches/breakers must be labelled to indicate their purpose.\r\r\n- Electrical contacts should not be exposed (e.g. no loose wires, no frayed cables).\r\r\n- Electric wires should be in good condition (e.g., enclosed in non-flammable material, no burnt insulation), and they should be secured so they do not obstruct workplaces or create a tripping hazard.\r\r\n\r\r\nIf the above, at a minimum, is not followed by the facility, answer No to this question. \r\r\n\r\r\nIn addition to the above, other additional applicable legal requirements may apply and must also be followed. If the facility is not following applicable legal requirements, answer No to this question. ',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-ele-14',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16560,
  sectionId: '2.2.9.9',
  impactArea: 'Electrical Safety',
  impactAreaId: 'ELECTRICAL_SAFETY',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
